/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import Compiled from '../../compiled/components/internal/dummy-input';
export default function DummyInput(props) {
  return /*#__PURE__*/React.createElement(Compiled, props);
}